export const captions = [
  "Buzz Aldrin, the Lunar Module pilot, egresses the LM. Image taken at Tranquility Base.",
  "The -Y footpad of the Lunar Module is visible\non the surface of the Moon",
  "Buzz Aldrin Lunar Module pilot, descends from the  LM, climbing down the ladder.  Lunar horizon visible in background. Image taken at Tranquility Base.",
  "Buzz Aldrin climbs down the LM ladder, preparing for his first steps on the Moon",
  "Buzz descends from the LM, climbing down the ladder.",
  "Buzz Aldrin holds onto the ladder as he stands on the LM footpad before stepping onto the Moon’s surface",
  "Armstrong bootprint on the lunar surface",
  "Buzz Aldrin poses for a photo beside the U.S. flag that has been placed on the moon. the LM is visible\nin the left field of the view. Numerous footprints and the cable of the surface television camera are visible\non the lunar surface in the foreground.",
];
